import type * as React from 'react';

type Props = {
  degreeHeader?: React.ReactNode;
  enterpriseHeader?: React.ReactNode;
  consumerHeader?: React.ReactNode;
  loggedOutHeader?: React.ReactNode;
  userId?: number;
  showDegree?: boolean;
  showEntProgram?: boolean;
};

/**
 * Handles automatic switching between Degree, Enterprise, Consumer, and an optional Logged Out header.
 * If no loggedOutHeader specified, assumes the consumerHeader handles logged in & logged out.
 */
const HeaderContextSwitcher = ({
  degreeHeader,
  enterpriseHeader,
  consumerHeader,
  loggedOutHeader,
  userId,
  showDegree,
  showEntProgram,
}: Props) => {
  if (userId !== undefined && showDegree && !!degreeHeader) {
    return degreeHeader;
  } else if (userId !== undefined && showEntProgram && !!enterpriseHeader) {
    return enterpriseHeader;
  } else if (userId !== undefined && !!consumerHeader) {
    return consumerHeader;
  } else if (userId === undefined && !!loggedOutHeader) {
    // Offer option for logged out header if using logged-in only consumer header
    return loggedOutHeader;
  } else if (consumerHeader) {
    // Otherwise just use consumerHeader, assumes handling both logged in & logged out
    return consumerHeader;
  } else {
    // If nothing supplied, return nothing to handle errors
    return null;
  }
};

export default HeaderContextSwitcher;
